import { Controller } from "@hotwired/stimulus";

import { modalIcon, modalType } from "../../icons/modalIcon";

export default class extends Controller {
  static targets = ["modalTitle", "modalContent", "modalIcon", "form", "button", "fieldset"]
  static classes = [ "error" ]
  static values = {
    errorTitle: String,
    errorContent: String,
    baseTitle: String,
    baseContent: String
  }

  initialize() {
    this.formTarget.addEventListener('keydown', e => {
      if (e.keyCode == 13) {
        e.preventDefault()
        return false
      }
    })
  }

  connect() {
    this.formTarget.reset()
    this.fieldsetTargets.forEach(fieldset => {
      fieldset.parentNode.classList.remove(...this.errorClasses)
    })
  }

  send() {
    let invalidItemCounter = 0

    this.fieldsetTargets.forEach(fieldset => {
      const checkedElements = Array.from(fieldset.getElementsByTagName('input')).filter(el => el.checked)

      if (checkedElements.length === 0) {
        fieldset.parentNode.classList.add(...this.errorClasses)
        invalidItemCounter++
      } else {
        fieldset.parentNode.classList.remove(...this.errorClasses)
      }
    })

    if (invalidItemCounter > 0) {
      this._updateModal(modalIcon(modalType.ALERT), this.errorTitleValue, this._errorContentMsg(invalidItemCounter), this._addHidden)
    } else {
      this._updateModal(modalIcon(modalType.DONE), this.baseTitleValue, this.baseContentValue, this._removeHidden)
    }
  }

  _updateModal(icon, title, content, action) {
    this.modalIconTarget.innerHTML = icon
    this.modalTitleTarget.innerText = title
    this.modalContentTarget.innerText = content
    this.buttonTargets.forEach(action)
  }

  _errorContentMsg(invalidItemCounter) {
    return this.errorContentValue.replace('%{invalidItemCounter}', invalidItemCounter)
  }

  _addHidden(element) {
    element.style.display = 'none'
  }

  _removeHidden(element) {
    element.style.display = ''
  }
}
